import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from "@angular/core";
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import * as moment from "moment";
import _ from "lodash";
import { AuthorityService } from "@root/shared/business-sevice/authority.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs";
import { PlatformType } from "@root/config";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { DateService } from "@root/shared/service/date.service";
import { Child, MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";

enum HouseType {
  House = 0,
  Type = 1,
}

type PriceChild = Child & {
  thirdparty_type: number;
};

@Component({
  selector: "host-channel-panel",
  templateUrl: "./channel-panel.component.html",
  styleUrls: ["./channel-panel.component.scss"],
})
export class ChannelPanelComponent implements OnInit, OnDestroy {
  @Input() dateRange: Array<string | Date> = [];
  // @Input() readonly nights;
  @Input() entity: PriceChild;
  @Input() set listOfCalendar(value) {
    this.updateDataByThirdparty(value);
  }
  @Output() success = new EventEmitter();

  get houseType(): HouseType {
    return this.entity?.c_parent?.p_type;
    // return this.relatedHouse && this.relatedHouse.type;
    // return (this.entity?.payload as Child)?.c_parent?.p_type;
    // return _.get(this.relatedHouse, 'related.type');
  }

  get nights() {
    const h = moment(_.head(this.dateRange));
    const l = moment(_.last(this.dateRange));
    return l.diff(h, "days") + 1;
  }
  nzFormat = this.dateService.getAngularFormat(["YMD"]);
  listOfDataByThirdparty = [];
  _available = -1; // 一键修改
  get available() {
    return this._available;
  }
  set available(val) {
    this._available = val;
    _.forEach(this.listOfDataByThirdparty, (item) => (item.available = val));
  }

  _stock = null; // 一键修改
  get stock() {
    return this._stock;
  }
  set stock(val) {
    this._stock = val;
    _.forEach(this.listOfDataByThirdparty, (item) => (item.stock = val));
  }

  // get nights() {
  //   return moment(this.dateRange[1]).diff(moment(this.dateRange[0]), 'd');
  // }

  get hasBooking() {
    return _.find(this.listOfDataByThirdparty, (item) => this.isBooking(item.thirdparty_type));
  }
  private destroy$ = new Subject();
  disabledDate = (date) => {
    const head = moment().subtract(1, "d");
    const last = moment().add(2, "year");

    return !moment(date).isBetween(head, last, "d");
  };
  constructor(
    private httpService: HouseStatusService,
    private messageService: NzMessageService,
    private houseCalendarService: MultiHouseCalendarService,
    private translate: TranslateService,
    private dateService: DateService,
  ) {}

  ngOnInit() {
    this.houseCalendarService.requestUpdateChannelAvailableRaw$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      console.log("res: ", res);
      this.requestUpdateStock(res);
    });
  }

  updateDataByThirdparty(keys: Array<any> = []) {
    console.log("channel panel: related house: ", this.entity);
    if (this.houseType === HouseType.House) {
      this.listOfDataByThirdparty = this.updateAvailable(keys);
    } else {
      this.listOfDataByThirdparty = this.updateStock(keys);
    }
    console.log("[channel panel listOfDataByThirdparty]", this.listOfDataByThirdparty);
  }

  private updateAvailable(list) {
    return _.map(list, (_key) => {
      const key = { ..._key };
      const calendar = key.calendar;

      if (key.thirdparty_type === PlatformType.Ctrip) {
        const orderByReservePrice = _.orderBy(calendar, ["reserve_price"]);
        const minReservePrice = _.head(orderByReservePrice);
        const maxReservePrice = _.last(orderByReservePrice);

        key.ctrip_reserve_price_range =
          minReservePrice === maxReservePrice ? minReservePrice : `${minReservePrice}-${maxReservePrice}`;
        key.commission_rate = key.commission_rate;
      }

      let minimum_stay = null;
      let closed_on_arrival = null;
      if (this.isBooking(key.thirdparty_type)) {
        const first = calendar[0];
        if (calendar.every((date) => date.minimum_stay === first.minimum_stay)) {
          minimum_stay = first.minimum_stay;
        }
        if (calendar.every((date) => date.closed_on_arrival === first.closed_on_arrival)) {
          closed_on_arrival = first.closed_on_arrival;
        }

        key.minimum_stay = minimum_stay;
        key.closed_on_arrival = closed_on_arrival;
      }

      // let minimum_stay = null;
      // let closed_on_arrival = null;
      // if (this.isBooking(key.thirdparty_type)) {
      //   const first = calendar[0];
      //   if (calendar.every(date => date.minimum_stay === first.minimum_stay)) {
      //     minimum_stay = first.minimum_stay;
      //   }
      //   if (calendar.every(date => date.closed_on_arrival === first.closed_on_arrival)) {
      //     closed_on_arrival = first.closed_on_arrival;
      //   }
      //
      //   key.minimum_stay = minimum_stay;
      //   key.closed_on_arrival = closed_on_arrival;
      // }

      let available = -1;
      const total = _.reduce(calendar, (sum, n) => sum + n.available, 0);

      if (total === 0) {
        available = 0;
      } else if (total === calendar.length) {
        available = 1;
      }

      key.available = available;
      // key.houseInfo = this.entity as Child;
      // key.houseInfo = this.relatedHouse.related.p_children.find((house) => house.unique_key === _key.unique_key);

      if (this.entity.c_id === key.unique_key) {
        key.expand = true;
      }
      return key;
    });
  }

  private updateStock(list) {
    console.log("related house: ", this.entity);
    const currentThirdparty = this.entity?.thirdparty_type;
    const currentUniqueKey = this.entity?.c_id;
    // const currentThirdparty = this.relatedHouse.currentThirdparty;
    // const currentUniqueKey = this.relatedHouse.currentId;

    return _.map(list, (_key) => {
      const key = { ..._key };
      const calendar: any[] = key.calendar;

      if (key.thirdparty_type === PlatformType.Ctrip) {
        const orderByReservePrice = _.orderBy(calendar, ["reserve_price"]);
        const min = _.head(orderByReservePrice);
        const max = _.last(orderByReservePrice);

        key.ctrip_reserve_price_range =
          min.reserve_price === max.reserve_price ? min.reserve_price : `${min.reserve_price}-${max.reserve_price}`;
        key.commission_rate = min.commission_rate;
      }

      let minimum_stay = null;
      let closed_on_arrival = null;
      if (this.isBooking(key.thirdparty_type)) {
        const first = calendar[0];
        if (calendar.every((date) => date.minimum_stay === first.minimum_stay)) {
          minimum_stay = first.minimum_stay;
        }
        if (calendar.every((date) => date.closed_on_arrival === first.closed_on_arrival)) {
          closed_on_arrival = first.closed_on_arrival;
        }

        key.minimum_stay = minimum_stay;
        key.closed_on_arrival = closed_on_arrival;
      }

      let stock = null;
      let placeholder = "";
      const inventory = _.head(calendar).inventory;
      /**
       * 每一天的库存都相同，则将该房源的stock置为inventory，其他房源的placeholder置为inventory
       * 当每天库存存在不同时，产品需求不显示，所以无需处理
       */
      if (_.every(calendar, (date) => date.inventory === inventory)) {
        if (key.thirdparty_type === currentThirdparty && _.toString(key.unique_key) === _.toString(currentUniqueKey)) {
          stock = inventory;
        } else {
          placeholder = inventory;
        }
      }

      key.stock = stock;
      key.placeholder = placeholder;

      // key.houseInfo = this.entity as Child;
      // key.houseInfo = this.relatedHouse.related.p_children.find((house) => house.unique_key === _key.unique_key);
      if (this.entity.c_id === key.unique_key) {
        key.expand = true;
      }
      return key;
    });
  }

  changeDate(value) {
    const head = moment(_.head(value));
    const last = moment(_.last(value));

    // /** 检查选择的日期之间是否有订单 */
    // while (this.hasDisabledBetween(head, last)) {
    //   last.subtract(1, 'd');
    // }

    // const id = this.id;
    // const id = this.relatedHouse.currentId;
    // const id = this.entity.c_id;

    this.dateRange = [head.toDate(), last.toDate()];

    // this.houseCalendarService.select({
    //   status: 'done',
    //   dates: { head, last },
    //   data: { type: 'house', payload: this.entity },
    // });
  }

  checkDateIsInRange() {
    const end = _.last(this.dateRange);
    const endLimit = moment().add(6, "month");

    if (endLimit.isAfter(end, "d")) {
      return true;
    }
    // 仅可操作7个月内的日期
    const warningText = this.translate.syncGet("warning.available_within_seven_months");
    this.messageService.info(warningText);
    return false;
  }

  /**
   * 如果设置data，则用data的值强行覆盖，不考虑实际填写的值
   */
  private requestUpdateStock(data?: { available: 0 | 1; thirdparty?: number }) {
    console.log("[data]: ", data);
    console.log("[related]: ", this.entity);
    const edit_type = "house_status";
    const version = "2.4";
    const type = this.houseType;
    // const relation_id = _.get(this.entity, 'related.relation_id');
    const relation_id = this.entity?.c_parent?.p_id;
    const thirdparty_list = this.getThridpartyListParams(data);
    // const thirdparty_list = _.map(this.listOfDataByThirdparty, item => {
    //   console.log("[item]: ", item);
    //   let inventory;
    //   /** 只有操作的是该房子，才修改 */
    //   if (
    //     !_.isUndefined(data) &&
    //     this.relatedHouse.currentThirdparty === item.thirdparty_type &&
    //     _.toString(this.relatedHouse.currentId) === _.toString(item.unique_key)
    //   ) {
    //     /**
    //      * 如果没传thirdparty，说明要修改所有平台的房态，否则，是修改传入的平台对应的房态
    //      */
    //     if (
    //       !_.isNil(data.thirdparty) &&
    //       data.thirdparty === item.thirdparty_type
    //     ) {
    //       console.log("inventory = data.available;");
    //       inventory = data.available;
    //     } else {
    //       console.log("inventory = null");
    //       // inventory = item.available;
    //       inventory = null;
    //     }
    //   } else {
    //     inventory = type === HouseType.House ? item.available : item.stock;
    //   }
    //   const unique_key = item.unique_key;
    //   return { unique_key, inventory };
    // });
    console.log("thirdparty_list: ", thirdparty_list);
    const begin = moment(_.head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(_.last(this.dateRange)).format("YYYY-MM-DD");

    this.httpService
      .updatePriceOrStock({
        version,
        relation_id,
        type,
        edit_type,
        begin,
        end,
        thirdparty_list: JSON.stringify(thirdparty_list),
      })
      .subscribe((res) => {
        console.log("res: ", res);
        if (res && res.error_code === 0) {
          this.refreshCalendar();
          this.success.emit();
        }
      });
  }

  private getThridpartyListParams(data?: { available: 0 | 1; thirdparty?: number }) {
    const house = this.entity;
    const list = this.listOfDataByThirdparty;

    if (data) {
      /** 外部调用 */
      if (!_.isNil(data.thirdparty)) {
        /** 单独修改某一个平台 */
        const thirdparty = _.find(
          list,
          (item) =>
            item.thirdparty_type === house.thirdparty_type && _.toString(house.c_id) === _.toString(item.unique_key),
        );

        return thirdparty ? [{ unique_key: thirdparty.unique_key, inventory: data.available }] : [];
      } else {
        /** 修改所有平台，目前好像没有这种情况 */
        return _.map(list, (item) => ({
          unique_key: item.unique_key,
          inventory: data.available,
        }));
      }
    } else {
      /** 本组件调用 */
      const type = this.houseType;
      return _.map(list, (item) => {
        const rst = {
          unique_key: item.unique_key,
          inventory: type === HouseType.House ? item.available : item.stock,
        };
        if (item.thirdparty_type === PlatformType.Booking) {
          Object.assign(rst, {
            closed_on_arrival: item.closed_on_arrival,
            minimum_stay: item.minimum_stay,
          });
        }
        return rst;
      });
    }
  }

  onClickCancel() {
    this.success.emit();
  }

  @WritePermissionGurd("rate")
  onClickSave() {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: "暂无修改权限，请联系管理员"
    //   });
    //   return;
    // }

    // if (!this.checkDateIsInRange()) {
    //   return;
    // }

    this.requestUpdateStock();
  }

  isBooking(thirdparty) {
    return +thirdparty === PlatformType.Booking;
  }

  refreshCalendar() {
    this.houseCalendarService.calendarRefreshRaw$.next(null);
  }

  // hasWritePermission() {
  //   return this.authorityService.hasWritePermission("calendar");
  // }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
